import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { isLoggedIn } from '../../utils/auth';

const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4613/auth';

export const usersApi = createApi({
  reducerPath: 'usersApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${baseUrl}`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token');
      if (token && isLoggedIn()) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  keepUnusedDataFor: 0,
  tagTypes: ['Users'],
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: (params = {}) => ({
        url: '/users-list',
        method: 'POST',
        body: {
          page: params.page,
          limit: params.limit,
          search: params.search,
          block_user: params.block_user ? 1 : 0,
          status: params.status !== undefined && params.status !== '' ? parseInt(params.status, 10) : 0,
          role_id: params.role_id !== undefined && params.role_id !== '' ? parseInt(params.role_id, 10) : -1
        }
      }),
      providesTags: ['Users'],
    }),
    
    getUser: builder.query({
      query: (userId) => `/users/${userId}`,
      providesTags: (result, error, userId) => [{ type: 'Users', id: userId }],
    }),
    
    createUser: builder.mutation({
      query: (userData) => ({
        url: '/users',
        method: 'POST',
        body: userData,
      }),
      invalidatesTags: ['Users'],
    }),
    
    updateUser: builder.mutation({
      query: ({ userId, ...userData }) => ({
        url: `/users/${userId}`,
        method: 'PUT',
        body: userData,
      }),
      async onQueryStarted({ userId, ...userData }, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          // Refetch the user data immediately after update
          dispatch(
            usersApi.util.invalidateTags([{ type: 'Users', id: userId }])
          );
        } catch {}
      },
      invalidatesTags: (result, error, { userId }) => [
        { type: 'Users', id: userId },
        'Users',
      ],
    }),
    
    deleteUser: builder.mutation({
      query: (userId) => ({
        url: `/users/${userId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Users'],
    }),
  }),
});

export const {
  useGetUsersQuery,
  useGetUserQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
} = usersApi; 